const boardRouters = {
  path: "/board",
  component: () => import("@/views/layout"),
  name: "board",
  meta: { public: true, theme: "none" },
  children: [
    {
      path: "edit",
      component: () => import("@/views/Backend/Admin/Statistics/BoardEdit"),
      name: "board-edit"
    },
    {
      path: "preview",
      component: () => import("@/views/Backend/Admin/Statistics/BoardPreview"),
      name: "board-preview"
    },
    {
      path: "full",
      component: () => import("@/views/Backend/Admin/Statistics/FullBoard"),
      name: "board-full"
    },
    {
      path: "chart-edit",
      component: () => import("@/views/Backend/Admin/Statistics/chartEdit"),
      name: "chart-edit"
    },
    {
      path: "app",
      component: () => import("@/views/Backend/Admin/Statistics/Phone"),
      name: "board-app"
    },
    {
      path: "share/:boardId/:shareId/:boardName",
      component: () => import("@/views/Backend/Admin/Statistics/Share/BoardShare"),
      name: "board-share"
    },
    {
      path: "share/full",
      component: () => import("@/views/Backend/Admin/Statistics/Share/FullBoardShare"),
      name: "board-share-full"
    }
  ]
}

export default boardRouters
